"use client";

import dynamic from "next/dynamic";
import { ComponentType, FC, useState } from "react";
import Conditional from "@repo/shared-ui/Conditional";
import useModalCloseOnBrowserButton from "@repo/shared-ui/useModalCloseOnBrowserButton";
import { IStockPerformanceContent } from "../../interfaces/StockPerformance.interface";
import { decodeHtmlEntities } from "@repo/shared-utils/common-utils";
import { handleCloseBtnDL, handleInfoIconDL } from "./StockPerformanceFunction";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";

// load modal only if clicked
const BFLModal: ComponentType<any> = dynamic(
  () => import("@repo/shared-ui/BFLModal") as any,
  { ssr: false },
);

interface StockPerformanceModalProps {
  content: IStockPerformanceContent;
}

const StockPerformanceModal: FC<StockPerformanceModalProps> = ({ content }) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const sectionTitle = content?.titleText || "Stock Performance";

  const handleOpen = () => {
    setIsModalOpen(true);
    handleInfoIconDL(loginStatus, sectionTitle);
  };

  const handleClose = () => {
    setIsModalOpen(false);
    handleCloseBtnDL(
      loginStatus,
      sectionTitle,
      content?.popUpCTAText ?? "",
      false,
    );
  };

  useModalCloseOnBrowserButton(isModalOpen, handleClose);

  return (
    <>
      <button
        className="text-link-primary cursor-pointer text-base"
        onClick={handleOpen}
      >
        <i className="icomoon before:content-['\e907']" />
      </button>

      <Conditional if={isModalOpen}>
        <BFLModal
          isOpen={isModalOpen}
          onClose={handleClose}
          title={content?.popUpTitleText ?? ""}
          description={content?.popUpSubTitleText ?? ""}
          buttonText={content?.popUpCTAText ?? ""}
          enableScroll={
            !(typeof window !== "undefined" && window.innerWidth <= 768)
          }
        >
          <div
            className="text-link-secondary modal-wrap text-xs md:text-sm"
            dangerouslySetInnerHTML={{
              __html: decodeHtmlEntities(content?.popUpDescriptionText ?? ""),
            }}
          ></div>
        </BFLModal>
      </Conditional>
    </>
  );
};

export default StockPerformanceModal;
